export const types = {
    SAVETOMATEDRIVE: 'SAVE-TO-MATE-DRIVE',
    DELETEFROMMATEDRIVE: 'DELETE-FROM-MATE-DRIVE'
};
